import React, { useState } from 'react';
//@ts-ignore
import * as styles from './support-masthead.module.css';
//@ts-ignore
import * as autocompletestyles from './autocomplete.module.css';
import { SupportMastheadProps, MappedProductFamily } from './index';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import CtaLink from '../Global/CtaLink';
import { InstantSearch, connectAutoComplete } from 'react-instantsearch-dom';

import AutoSuggest from '../Global/LazyAutoSuggest';
//import { navigate } from 'gatsby';
import { navigate } from 'gatsby-link';
//@ts-ignore
import {
    getMediaData,
    optimizeKontentImageUrl,
    imagePreset,
    getDisplayDimensions,
    buildKontentSrcSet,
} from '../Global/DataUtils';
import { searchClient } from '../Global/DataUtils/algolia';
import LazyImage from '../Global/LazyImage';
import { BlogPagePreview } from '../Global/DataUtils/blogQueries';
import { getLangPrefix } from '../../global/countries';
import {
    getAlgoliaIndexPrefix,
    getAlgoliaLangSuffix,
} from '../../global/utility';
import CustomHeadline from '../Global/CustomHeadline';

interface Props extends SupportMastheadProps {
    productFamilyContent: MappedProductFamily[];
    supportProducts: MappedProductFamily[];
    preferredLanguage?: String;
    supportPages?: BlogPagePreview[];
}

const SupportMasthead: React.FC<Props> = ({
    preferredLanguage = 'default',
    content_position,
    general_large___small_image_selection__large,
    general_large___small_image_selection__small,
    ghosted_icon_image,
    headline,
    headline_tag,
    headline_style,
    general_search_hint_text,
    general_search_subheadline,
    product_selection_hint_text,
    product_selection_subheadline,
    under_image_bar_color,
    under_image_bar_show_or_hide,
    search_results_page,
    supportProducts,
    kontentItemId,
    ...props
}) => {
    const [selectedProductFamily, setSelectedProductFamily] = useState('');
    const [selectedProduct, setSelectedProduct] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [formError, setFormError] = useState('');
    const largeBgImage = getMediaData(
        general_large___small_image_selection__large
    );
    const smallBgImage = getMediaData(
        general_large___small_image_selection__small
    );
    let productsTemp = [] as MappedProductFamily['products'];
    const [filteredProducts, setFilteredProducts] = useState(productsTemp);
    const algoliaIndexPrefix = getAlgoliaIndexPrefix(
        process.env.GATSBY_ALGOLIA_ENV
    );
    // Algolia index suffixes are case-sensitive (e.g. `_GB-en`, `_AU-en`)
    // while preferredLanguage may be lowercased — denormalize before use.
    let indexName = `${algoliaIndexPrefix}ProductSupportPages_${getAlgoliaLangSuffix(
        preferredLanguage as string | undefined
    )}`;
    const searchResultsPage =
        search_results_page?.value &&
        search_results_page?.value[0]?.elements?.slug?.url;
    const ghostedIconImage = getMediaData(ghosted_icon_image);

    const handleChangeFamily = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        for (let i = 0; i < supportProducts.length; i++) {
            if (supportProducts[i].familyId === event.target.value) {
                productsTemp = supportProducts[i].products;
            }
        }

        setFilteredProducts(productsTemp);
        setSelectedProduct('');
        setSelectedProductFamily(event.target.value);
    };

    const handleChangeProduct = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        if (formError) {
            setFormError('');
        }
        setSelectedProduct(event.target.value);
    };

    const handleAutoCompleteChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        { newValue, ...rest }: { newValue: string }
    ) => {
        if (formError && newValue) {
            setFormError('');
        }

        if (newValue !== searchTerm) {
            setSearchTerm(newValue);
        }
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const langPrefix = getLangPrefix(preferredLanguage as string);
        if (searchTerm && searchResultsPage) {
            // redirect to search page if search text entered

            navigate(langPrefix + searchResultsPage, { state: { searchTerm } });
        }

        if (selectedProduct) {
            // redirect to product page if selectedProduct set
            navigate(langPrefix + selectedProduct);
        }

        if (!searchTerm && !selectedProduct) {
            setFormError('Please enter search term or select product.');
        }
    };

    return (
        <section
            className={styles.supportMasthead}
            data-kontent-item-id={kontentItemId}
        >
            <InstantSearch indexName={indexName} searchClient={searchClient}>
                {largeBgImage || smallBgImage ? (
                    <div className={styles.imageWrap}>
                        <picture data-kontent-element-codename="general_large___small_image_selection__large">
                            {smallBgImage && (
                                <source
                                    srcSet={buildKontentSrcSet(
                                        smallBgImage.url,
                                        imagePreset.halfWidth.mobile.w,
                                        {
                                            fm: 'webp' as const,
                                            q: imagePreset.halfWidth.mobile.q,
                                        }
                                    )}
                                    sizes="100vw"
                                    media="(max-width: 480px)"
                                    {...getDisplayDimensions(
                                        smallBgImage.width,
                                        smallBgImage.height,
                                        imagePreset.halfWidth.mobile.w
                                    )}
                                />
                            )}
                            {largeBgImage && (
                                <LazyImage
                                    src={optimizeKontentImageUrl(
                                        largeBgImage.url,
                                        imagePreset.fullWidth.desktop
                                    )}
                                    srcSet={buildKontentSrcSet(
                                        largeBgImage.url,
                                        imagePreset.fullWidth.desktop.w,
                                        {
                                            fm: 'webp' as const,
                                            q: imagePreset.fullWidth.desktop.q,
                                        }
                                    )}
                                    sizes="100vw"
                                    alt={largeBgImage?.description || ''}
                                    {...getDisplayDimensions(
                                        largeBgImage.width,
                                        largeBgImage.height,
                                        imagePreset.fullWidth.desktop.w
                                    )}
                                    priority
                                />
                            )}
                        </picture>
                    </div>
                ) : null}
                <div className={styles.formPanel}>
                    <div className={styles.formPanelContent}>
                        <CustomHeadline
                            style={
                                headline_style?.value[0]?.codename
                                    ? headline_style?.value[0]?.codename
                                    : 'h2'
                            }
                            tag={
                                headline_tag?.value[0]?.codename
                                    ? headline_tag
                                    : {
                                          value: [
                                              { codename: 'h1', name: 'h1' },
                                          ],
                                      }
                            }
                            headline_value={headline}
                            className={styles.customHeadline}
                            alignment={{ value: [{ codename: 'left' }] }}
                            overrideStyles={{ lineHeight: '1' }}
                            elementCodename="headline"
                        />
                        <form onSubmit={handleFormSubmit}>
                            <div
                                className={`${styles.formItem} ${styles.formItemSearch}`}
                            >
                                <label
                                    htmlFor="search"
                                    data-kontent-element-codename="general_search_subheadline"
                                >
                                    {general_search_subheadline.value}
                                </label>
                                <div className={styles.autocomplete}>
                                    <AutoComplete
                                        onChange={handleAutoCompleteChange}
                                        placeholder={
                                            general_search_hint_text.value
                                        }
                                        value={searchTerm}
                                    />
                                </div>
                            </div>
                            <div className={styles.formItem}>
                                <label
                                    htmlFor="product-family"
                                    data-kontent-element-codename="product_selection_subheadline"
                                >
                                    {product_selection_subheadline.value}
                                </label>
                                <div
                                    className={`${styles.selectWrapper} select-wrapper`}
                                >
                                    <select
                                        id="product-family"
                                        name="product-family"
                                        value={selectedProductFamily}
                                        onChange={handleChangeFamily}
                                    >
                                        <option disabled={true} value="">
                                            {product_selection_hint_text.value}
                                        </option>
                                        {supportProducts?.map((family, i) => (
                                            <option
                                                key={family.familyId}
                                                value={family.familyId}
                                            >
                                                {family.familyName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            {selectedProductFamily && (
                                <div className={styles.formItem}>
                                    <label
                                        htmlFor="product"
                                        className="sr-only"
                                    >
                                        pick your product
                                    </label>
                                    <div
                                        className={`${styles.selectWrapper} select-wrapper`}
                                    >
                                        <select
                                            id="product"
                                            name="product"
                                            value={selectedProduct}
                                            onChange={handleChangeProduct}
                                        >
                                            <option disabled={true} value="">
                                                pick your product
                                            </option>
                                            {filteredProducts?.map(
                                                (product) => {
                                                    if (
                                                        product.productName?.includes(
                                                            '--'
                                                        )
                                                    ) {
                                                        const wordParts =
                                                            product.productName.split(
                                                                '--'
                                                            );

                                                        product.productName =
                                                            wordParts
                                                                .filter(
                                                                    (p) =>
                                                                        p !=
                                                                        '--'
                                                                )
                                                                .join('');
                                                    }

                                                    return (
                                                        <option
                                                            key={
                                                                product.productId
                                                            }
                                                            value={
                                                                product.productUrl
                                                            }
                                                        >
                                                            {
                                                                product.productName
                                                            }
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </select>
                                    </div>
                                </div>
                            )}
                            {formError && (
                                <p className={styles.formError}>{formError}</p>
                            )}
                            <div className={styles.formActions}>
                                <button type="submit">GO</button>
                                {props.cta_configuration__cta_window_action &&
                                    props.cta_configuration__cta_location && (
                                        <CtaLink
                                            href={BuildLinkHref(
                                                props.cta_configuration__cta_location
                                            )}
                                            target={props.cta_configuration__cta_window_action.value.toString()}
                                            visualStyle="outlineLight"
                                        >
                                            {
                                                props
                                                    .cta_configuration__cta_label
                                                    ?.value
                                            }
                                        </CtaLink>
                                    )}
                            </div>
                        </form>
                        {ghostedIconImage?.url && (
                            <div
                                className={styles.ghostedIcon}
                                data-kontent-element-codename="ghosted_icon_image"
                            >
                                <LazyImage
                                    src={ghostedIconImage.url}
                                    alt=""
                                    // Decorative, object-fit: none; SVGs
                                    // carry no Kontent dimensions.
                                    width={ghostedIconImage.width || 400}
                                    height={ghostedIconImage.height || 400}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </InstantSearch>
        </section>
    );
};

const AutoComplete = connectAutoComplete(({ hits, refine, ...props }) => {
    const updateSuggestions = (req: any) => {
        refine(req.value);
    };

    const clearSuggestions = () => {
        refine('');
    };

    return (
        <AutoSuggest
            theme={autocompletestyles}
            suggestions={hits}
            onSuggestionsFetchRequested={updateSuggestions}
            onSuggestionsClearRequested={clearSuggestions}
            getSuggestionValue={(hit: any) => hit.display_page_name}
            focusInputOnSuggestionClick={false}
            renderSuggestion={(hit: any) => {
                return <p key={hit.objectID}>{hit.display_page_name}</p>;
            }}
            inputProps={{
                id: 'search',
                placeholder: props.placeholder,
                value: props.value,
                onChange: (
                    suggestChangeEvent: React.ChangeEvent<HTMLInputElement>,
                    rest
                ) => {
                    props.onChange(suggestChangeEvent, rest);
                },
            }}
        />
    );
});

export default SupportMasthead;
